<div class="space-y-6">
  <app-page-header
    [backTo]="['/roles', role()?.name]"
    backLabel="Retour à la fiche"
    title="Modifier le rôle"
  />

  @if (loadError() || loading()) {
    <app-data-state
      [loading]="loading()"
      [error]="loadError()"
      (retry)="fetch()"
    />
  } @else if (role(); as r) {
    <app-role-form
      mode="edit"
      [role]="r"
      [submitting]="submitting()"
      [serverError]="serverError()"
      (save)="onSave($event)"
      (cancel)="onCancel()"
    />
  }
</div>
